<template>
                    
        <div class="d-flex flex-column elevation-1" v-if="show_info && selected">
            <div class="expansion pa-2 font-weight-regular body-1 font-italic text-uppercase">{{title}}</div>
            <div class="d-flex flex-column body-2">
                <RowComponent
                    :label="'data ultimo intervento'"
                    :value="formatDate(c_metro.last_operation)">
                </RowComponent>
                <RowComponent
                    :label="'codice ultimo report'"
                    :value="c_metro.last_report"
                >
                <RowComponent
                    :label="'esito ultimo report'"
                    :value="c_metro.last_result"
                ></RowComponent>
                </RowComponent>
                <RowComponent
                    :label="'validità'"
                    :value="c_metro.period+' mesi'">
                </RowComponent>
                <RowComponent
                    :label="'scadenza'"
                    :value="formatDate(c_metro.next_operation)">
                </RowComponent>
                <CustomData
                    :o_data="c_metro.custom_data"
                    :family="family"
                    :c_type="'metro'"
                    :r_type="type"
                    :show_info="true"
                    ref="custom_data"/>
            </div>
        </div>
        <v-expansion-panel v-else-if="!show_info" class="elevation-0 pa-0 ma-0 pr-0">
            <v-expansion-panel-header color="expansion" class="ma-0 py-0">
                <div class="d-flex align-start justify-start flex-grow-1 flex-shrink-0">
                    <b class="font-italic">{{ title }}</b>
                </div>
                <slot name="selection">
                </slot>
                <!--div class="d-flex align-start justify-center flex-grow-0 flex-shrink-1">
                    <v-checkbox v-if="!show_info" v-model="selected" @click.stop.native/>
                </div-->
            </v-expansion-panel-header>
            <v-expansion-panel-content eager class="pa-0">
            <v-container class="pt-2 pb-0">
                <v-row no-gutters>
                    <v-col cols="4">
                        <NumericField dense outlined 
                            v-model="c_metro.period"
                            :precision="0"
                            disabled
                            :label="computedLabels"
                            suffix="mesi" 
                            :min="'1'"
                            :rules="[rules.mandatory]"
                            @blur="updateNextOperation">
                        </NumericField>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        class="pl-2"
                        label="codice ultimo report"
                        dense outlined
                        disabled
                        v-model="c_metro.last_report"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        class="pl-2"
                        label="esito ultimo report"
                        dense outlined
                        disabled
                        v-model="c_metro.last_result"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="6">
                        <CalendarField
                            v-model="c_metro.last_operation"
                            @input="updateNextOperation"
                            label="data intervento"
                            disabled
                            
                        />
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <CalendarField
                            v-model="c_metro.next_operation"
                            :minDate="c_metro.last_operation"
                            label="prossima scadenza"
                            disabled
                                
                        />
                    </v-col>
                </v-row>
            </v-container>
            <CustomData v-if="selected"
                :o_data="c_metro.custom_data"
                :family="family"
                :c_type="'metro'"
                :r_type="type"
                ref="custom_data"></CustomData>
        </v-expansion-panel-content>
        </v-expansion-panel>
</template>

<script>
import {getModel} from '../../../utils/model'
import {f_rules, formatDatefromTS} from '../../../utils/commonUtils'
import {i_families} from "../../../utils/common.js"
import CustomData from "./CustomData"
import RowComponent from "../../../components/utils/RowComponent"
// import _ from 'lodash'
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        metro: {
            type: Object,
            required: false,
            default: null
        },
        type: {
            type: String,
            required: false,
            default: null
        },
        family: {
            type: String,
            required: false,
            default: null
        },
        show_info: {
            type: Boolean,
            required: false,
            default: false
        },
        selected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: { CustomData, RowComponent },
    data() {
        return {
            rules: f_rules,
            families: i_families,
            c_metro: {}
        }
    },
    beforeMount() {
        this.reset()
    },
    watch: {
    },
    methods: {
        enableEdit() {
            if (!this.selected) {
                this.reset()
            }
        },
        reset() {
            if (this.metro && Object.keys(this.metro).length) {
                //this.selected = true
                this.c_metro = _.cloneDeep(this.metro)
                if (typeof this.c_metro.period == "string") {
                    this.c_metro.period = parseInt(this.c_metro.period)
                }
                this.$emit('expand_panel', )
            } else {
                //this.selected = false
                let MetroData = getModel('MetroData')
                let period = this.families[this.family].report[this.type].period || '12'
                this.c_metro = MetroData({
                    period: period                        
                })
                
            }
        },
        getData() {
            if (this.selected) {
                console.log('metro', this.c_metro)
                if(this.$refs.custom_data){
                    this.c_metro.custom_data = _.cloneDeep(this.$refs.custom_data.getData())
                }
                return this.c_metro
            }
            return {}
        },
        updateNextOperation() {
            console.log('update next Operation')
            if (this.c_metro.last_operation>0) {
                let d = new Date(this.c_metro.last_operation)
                console.log(d)
                this.c_metro.next_operation = d.setMonth(d.getMonth() + parseInt(this.c_metro.period))
            } 
        },
        
        isValid(){
            if(this.selected) {
                if (!!this.$refs.custom_data){
                    return this.$refs.custom_data.isValid()
                }
                return true
            }   
            return false
        },
        formatDate(ts) {
            return formatDatefromTS(ts)
        }

    },
    computed:{
        computedLabels(){
            if(this.type){
                switch(this.type){
                    case "leg": return "frequenza di verificazione"
                    case "iso":
                    case "iso_simple": return "frequenza di taratura"
                    default: return "frequenza"
                }
            }
            return "frequenza"
        }
    }
}
</script>

<style>

</style>